module.exports = __webpack_public_path__ + "static/media/21ECLAC20.91adc048.jpg";